import { WhyTdcNextOnVeraBreakthroughs } from "@/components/engagement/why-tdc-nextonvera-breakthroughs";
import { whyTdcNextOnVeraPage, type WhyPoint } from "@/content/why-tdc-nextonvera";
import { assetUrl } from "@/lib/asset-url";

const page = whyTdcNextOnVeraPage;

function PointList({ points }: { points: readonly WhyPoint[] }) {
  return (
    <ul className="mt-8 space-y-4">
      {points.map((point) => (
        <li key={point.title} className="border-border/70 bg-card/50 rounded-2xl border p-5 shadow-sm">
          <h3 className="font-display text-foreground text-lg font-semibold tracking-tight">
            {point.title}
          </h3>
          <p className="text-muted-foreground mt-2 text-sm leading-relaxed">{point.body}</p>
        </li>
      ))}
    </ul>
  );
}

export function WhyTdcNextOnVeraBody() {
  return (
    <>
      <section
        aria-labelledby="why-tdc-heading"
        className="px-4 py-12 sm:px-6 sm:py-16 lg:px-8"
      >
        <div className="mx-auto grid w-full max-w-7xl gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
              {page.tdc.eyebrow}
            </p>
            <h2
              id="why-tdc-heading"
              className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
            >
              {page.tdc.heading}
            </h2>
            <div className="mt-4 space-y-4">
              {page.tdc.body.map((paragraph) => (
                <p key={paragraph} className="text-muted-foreground text-base leading-relaxed sm:text-lg">
                  {paragraph}
                </p>
              ))}
            </div>
            <figure className="border-border/70 bg-card mt-8 overflow-hidden rounded-2xl border shadow-sm">
              <div className="relative aspect-video w-full">
                <iframe
                  src="https://www.youtube-nocookie.com/embed/rlz0GYxzKIc"
                  title="Tour De Cure video"
                  className="absolute inset-0 h-full w-full"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            </figure>
            <PointList points={page.tdc.points} />
          </div>

          <div>
            <p className="text-cta mb-3 text-xs font-medium tracking-[0.2em] uppercase">
              {page.nextonvera.eyebrow}
            </p>
            <h2
              id="why-nextonvera-heading"
              className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
            >
              {page.nextonvera.heading}
            </h2>
            <div className="mt-4 space-y-4">
              {page.nextonvera.body.map((paragraph) => (
                <p key={paragraph} className="text-muted-foreground text-base leading-relaxed sm:text-lg">
                  {paragraph}
                </p>
              ))}
            </div>
            <figure className="border-border/70 bg-card mt-8 overflow-hidden rounded-2xl border shadow-sm">
              <img
                src={assetUrl(page.nextonveraImage)}
                alt={page.nextonveraImageAlt}
                className="h-auto w-full object-contain object-center"
                decoding="async"
              />
            </figure>
            <PointList points={page.nextonvera.points} />
          </div>
        </div>
      </section>

      <WhyTdcNextOnVeraBreakthroughs />
    </>
  );
}
